import React, { FC } from 'react';
import styled from 'styled-components';
import { ContainerBase } from 'src/components/widgets/layouts';
import { SkeletonBlock, SkeletonStack } from 'src/components/widgets/skeleton';

const Layout = styled.div`
    display: flex;
    gap: 3rem;
    margin-top: 24px;
    flex-wrap: wrap;
`;

const Col = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const DamOptimizePageSkeleton: FC = () => (
    <ContainerBase>
        <SkeletonStack $gap='10px' $margin='0 0 24px'>
            <SkeletonBlock $width='260px' $height='28px' />
            <SkeletonBlock $width='60%' $height='14px' />
        </SkeletonStack>
        <SkeletonBlock $width='100%' $height='64px' $radius='8px' />
        <Layout>
            <Col style={{ width: '30%', minWidth: '240px' }}>
                {Array.from({ length: 7 }).map((_, index) => (
                    <SkeletonBlock key={index} $width='100%' $height='44px' $radius='6px' />
                ))}
            </Col>
            <Col style={{ flex: 1, minWidth: '320px' }}>
                <SkeletonBlock $width='100%' $height='44px' $radius='6px' />
                <SkeletonBlock $width='100%' $height='260px' $radius='8px' />
            </Col>
        </Layout>
    </ContainerBase>
);

export default DamOptimizePageSkeleton;
